// extracted by mini-css-extract-plugin
export var changeIcon = "_45-4";
export var container = "_45-0";
export var divider = "_45-7";
export var externalLinkIcon = "_45-1";
export var green = "_45-5";
export var helpCircleIcon = "_45-3";
export var iconButton = "_45-2";
export var red = "_45-6";